export const FETCH_USUARIOS_REQUEST = "FETCH_USUARIOS_REQUEST";
export const FETCH_USUARIOS_SUCCESS = "FETCH_USUARIOS_SUCCESS";
export const FETCH_USUARIOS_FAILURE = "FETCH_USUARIOS_FAILURE";
